import React, {Component} from 'react'
import {Button, Modal, Tabs} from 'antd'
import MapStatementForm from '../Forms/MapStatementForm'

const {TabPane} = Tabs

class MapStatementModal extends Component {
  render() {
    const {
      visibleMap,
      transaction,
      onCancelMap,
      mapping,
      fetchingTransaction,
      map,
      formMapRef,
    } = this.props
    return (
      <Modal
        title={'Map Transaction'}
        destroyOnClose={true}
        visible={visibleMap}
        onCancel={onCancelMap}
        width={1333}
        footer={
          <Button loading={mapping} type="primary" icon={'link'} onClick={map}>
            Map
          </Button>
        }>
        <MapStatementForm
          ref={formMapRef}
          loading={fetchingTransaction}
          transaction={transaction}
          {...this.props}
        />
      </Modal>
    )
  }
}

MapStatementModal.propTypes = {}
MapStatementModal.defaultProps = {}

export default MapStatementModal
